export const appHead = {"meta":[{"charset":"utf-8"},{"hid":"description","name":"description","content":""},{"property":"og:title","content":"เขียนคำอวยพรด้วยรูป"},{"property":"og:description","content":"เขียนคำอวยพรด้วยรูป"},{"property":"og:image","content":"https://www.photowish.com/images/logo01.png"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=no"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/pw-favicon.png"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":true},{"onload":"this.onload=null;this.rel='stylesheet'","rel":"preload","as":"style","href":"https://fonts.googleapis.com/css2?family=Prompt:ital@0;1&&display=swap"},{"onload":"this.onload=null;this.rel='stylesheet'","rel":"preload","as":"style","href":"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Thai&family=Dancing+Script&display=swap"},{"onload":"this.onload=null;this.rel='stylesheet'","rel":"preload","as":"style","href":"https://fonts.googleapis.com/css2?family=Cinzel&family=Noto+Sans+Thai&display=swap"}],"style":[],"script":[{"src":"/js/lineCallbackRedirect.js?v=1793876900401","description":"Redirect LINE login callback to /views/line-callback.html","type":"text/javascript"},{"src":"/js/singleTab.js?v=1793876900401","description":"Use the app in one tab at a time; older tabs go to Google","type":"text/javascript"},{"src":"/js/checkDotQuestion.js","crossorigin":"anonymous","description":"Browser does NOT support optional chaining.","type":"text/javascript"},{"src":"/js/safari.js","crossorigin":"anonymous","description":"Check IOS safari version","type":"text/javascript"},{"src":"/js/checkApp.js","crossorigin":"anonymous","description":"check app timeout load first page","type":"text/javascript"},{"src":"https://kit.fontawesome.com/5f5ed7ecf0.js","crossorigin":"anonymous","type":"text/javascript"},{"src":"https://firebasestorage.googleapis.com/v0/b/photowishv2.appspot.com/o/assets%2Fjs%2Fkonva9316.min.js?alt=media&token=56f9b90f-1b79-4477-9443-41ede451cdcb"},{"src":"https://unpkg.com/vconsole@latest/dist/vconsole.min.js"}],"noscript":[],"title":"เขียนคำอวยพรด้วยรูป","viewport":"width=device-width, initial-scale=1","charset":"utf-8"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true